export const GET_CONTACT_US_LIST = "GET_CONTACT_US_LIST"
export const GET_CONTACT_US_LIST_SUCCESS = "GET_CONTACT_US_LIST_SUCCESS"
export const GET_CONTACT_US_LIST_FAIL = "GET_CONTACT_US_LIST_FAIL"
